/*
 * This code is the intellectual property of Bulb Inc. and other software publishers.
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2022, Bulb Inc. For more information, please email contact@hellobulb.com.
*/

import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { DividerModule } from 'primeng/divider';
import { ToastModule } from 'primeng/toast';
import { TranslocoModule } from '@jsverse/transloco';
import { provideSvgIcons, SvgIconComponent } from '@ngneat/svg-icon';
import { fasEyeIcon } from 'IconLibrary/fontawesome/solid/eye';
import { faExclamationCircleIcon } from 'IconLibrary/fontawesome/regular/exclamation-circle';
import { faArrowAltCircleUpIcon } from 'IconLibrary/fontawesome/regular/arrow-alt-circle-up';
import { faCloneIcon } from 'IconLibrary/fontawesome/regular/clone';
import { faCopyIcon } from 'IconLibrary/fontawesome/regular/copy';
import { fasHeartIcon } from 'IconLibrary/fontawesome/solid/heart';
import { bulbCollectionIcon } from 'IconLibrary/bulb/collection';
import { TilesFooterIconComponent } from './tiles-footer/tiles-footer-icon/tiles-footer-icon.component';
import { TilesFooterComponent } from './tiles-footer/tiles-footer.component';
import { SVGIconModule } from '../svg-icon/svg-icon.module';
import { MenusModule } from '../menus/menus.module';
import { TilesTripleDotComponent } from './tiles-triple-dot/tiles-triple-dot.component';
import { BulbTilesTranslationProvider } from './translation-provider';

(fasHeartIcon as any).name = 'heart-solid';

@NgModule({
  declarations: [
    TilesTripleDotComponent,
    TilesFooterComponent,
    TilesFooterIconComponent,
  ],
  imports: [
    CommonModule,
    DividerModule,
    MenusModule,
    ToastModule,
    TranslocoModule,
    SvgIconComponent,
    SVGIconModule,
  ],
  exports: [
    TilesFooterComponent,
    TilesFooterIconComponent,
  ],
  providers: [
    BulbTilesTranslationProvider,
    DatePipe,
    provideSvgIcons([
      fasEyeIcon,
      faExclamationCircleIcon,
      faArrowAltCircleUpIcon,
      faCloneIcon,
      faCopyIcon,
      fasHeartIcon,
      bulbCollectionIcon]),
  ],
})
export class TilesModule { }
